import React from "react";
import { Box, CircularProgress } from "@mui/material";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const TextIconButtonComponent = ({ 
    onclick=()=>{}, 
    backgroundColor = '#9834F0', 
    borderColor="#9834F0", 
    textColor="#fff", 
    icon, 
    buttonStyleClass="btn btn-primary", 
    btnText,
    disabled = false,
    loading = false
}) => {
    return (<Box>
         <button 
            onClick={onclick} 
            style={{
                backgroundColor: disabled || loading ? '#e0e0e0' : backgroundColor, 
                borderColor: disabled || loading ? '#e0e0e0' : borderColor, 
                color: disabled || loading ? '#333333' : textColor,
                cursor: disabled || loading ? 'not-allowed' : 'pointer',
                opacity: 1
            }} 
            className={buttonStyleClass}
            disabled={disabled || loading}
        >
            <Box sx={{display:"flex", alignItems:"center", gap: 1, whiteSpace: 'nowrap'}}>
                {loading ? (
                    <CircularProgress size={16} sx={{color: '#333333'}} />
                ) : (
                    <FontAwesomeIcon icon={icon}/>
                )}
                <span style={{whiteSpace: 'nowrap'}}>{loading ? 'Downloading...' : btnText}</span>
            </Box>
        </button>
    </Box>);
}

export default TextIconButtonComponent;